import { render, staticRenderFns } from "./MaxLengthInput.vue?vue&type=template&id=5c37ca06&scoped=true"
import script from "./MaxLengthInput.vue?vue&type=script&lang=js"
export * from "./MaxLengthInput.vue?vue&type=script&lang=js"
import style0 from "./MaxLengthInput.vue?vue&type=style&index=0&id=5c37ca06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c37ca06",
  null
  
)

export default component.exports